import { CPDate } from '@cp-shared-19/common-utilities';

export type EarlyReturnPenaltyFormValues = {
    requestDate: CPDate;
    estimatedMileage: number;
    email?: string;
};

export const getInitialValues: () => EarlyReturnPenaltyFormValues = () => ({
    requestDate: '',
    estimatedMileage: 0,
});
